/**
 * Botão flutuante de suporte via WhatsApp — presente em todas as telas.
 */
import { MessageCircle } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/5519933004705?text=" + encodeURIComponent(
  "Olá! Vim pelo Sensorize STAT e gostaria de suporte."
);

export default function SupportButton() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="support-whatsapp-button"
      aria-label="Falar com o suporte no WhatsApp"
      className="fixed bottom-6 right-6 z-50 group flex items-center gap-2 pl-4 pr-5 py-3 rounded-full bg-[#25D366] hover:bg-[#128C7E] text-white font-semibold shadow-lg shadow-[#25D366]/30 transition-all duration-300 hover:scale-105"
    >
      <MessageCircle className="w-5 h-5" />
      <span className="text-sm">Suporte</span>
    </a>
  );
}
